import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import "../../assets/css/faq.css";
import faq from "../../assets/icons/TourIcon.svg";
import search from "../../assets/img/sreach---icon.svg";
import { getFaq } from "../../services/apiOtherlink";
import { ApiHelper } from "../../helpers/ApiHelper";
import { API } from "../../services/api";
const GuidedTourPopUp = (props) => {
  const [searchKey, setSearchKey] = useState('');
  const [videoArr, setVideoArr] = useState([]);
  useEffect(() => {
    fetchGuidedTour()
  }, [])

  const fetchGuidedTour = async () => {

   await ApiHelper.get(API.getSiteSettings)
             .then((resData) => {
                 setVideoArr(resData.data)
             })
             .catch((err) => {
               console.log(err, 'err');
             });


  }
    const GuidedTourClosePopup = () => {
    props.GuidedTourClosePopup();
   
  };
  const getEmbedUrl = (url) => {
    let videoUrl = null;
   const videoId = getYouTubeVideoId(url);
        if (videoId) {
          videoUrl = `https://www.youtube.com/embed/${videoId}`;
        }
        return videoUrl
};
// const getYouTubeVideoId = (url) => {
//   const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
//   const match = url.match(regExp);
//   return (match && match[2].length === 11) ? match[2] : null;
// };
const getYouTubeVideoId = (url = "") => {
  if (!url || typeof url !== "string") return null;

  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;

  const match = url.match(regExp);

  return match && match[2] && match[2].length === 11 ? match[2] : null;
};

  return (
    <div>
         <Modal dialogClassName="custom-modal modal-dialog-centered modal-dialog-scrollable" show={props.guidedTouropen} onHide={GuidedTourClosePopup}>
           <Modal.Header closeButton>
             <div className="popupheader">
               <div className="mod-bor-icon" >
                 <img src={faq} className="mod-icon black"></img>
               </div>
               <div className="header">
                 <h4 className="modal-tittle">Guided Tour</h4>
   
               </div>
             </div>
           </Modal.Header>
   
           <Modal.Body>
    <div class="">
       <iframe
    width="100%"
    height="400"
    src={`${getEmbedUrl(videoArr.guidedTourUrl)}`}
    title="YouTube video player"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
  ></iframe>


      </div>
           </Modal.Body>
           <Modal.Footer className="full-w" >
           
           </Modal.Footer>
         </Modal>
         
       </div>
  );
};
export default GuidedTourPopUp;
